import React from 'react';
import TablePage from '../../../../../components/pages/TablePage';

export default () => {
    const columns = [
        {
            selector: (row) => row?.no_aju,
            name: "No Aju",
            id: 'no_aju'
        },
        {
            selector: (row) => row?.no_increment,
            name: "No Increment",
            id: 'no_increment'
        },
        {
            selector: (row) => row?.name,
            name: "Name",
            id: 'name'
        },
        {
            selector: (row) => row?.airline_id?.name,
            name: "Airline",
            id: 'airline_id'
        },
    ]

    return (
        <TablePage
            title={"Master Aju"}
            url="api/v1/master_aju"
            actionPosition={'first'}
            createPath="/master/aju/create"
            editPath={"/master/aju/edit"}
            columns={columns}
        />
    )
}
